import { CSSObject } from '@chakra-ui/react';

export const FlexRaceAvailableWrapper: CSSObject = {
  color: 'white',
};
